/* eslint no-undef: 0 */

import angular from 'angular';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import round from 'lodash/round';

let privQuantity;

class DataService {
    constructor(jsonService, $rootScope, notificationService, $window, windowDimensionsService, apiService,
        config, sashesService, drawService, addMullionService, rulesService, $cookies, $translate, customDimensionColorRuleService, basementWindowRulesService, duplexMullionRulesService) {
        this.jsonService = jsonService;
        this.notificationService = notificationService;
        this.$rootScope = $rootScope;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.windowDimensionsService = windowDimensionsService;
        this.apiService = apiService;
        this.config = config;
        this.sashesService = sashesService;
        this.drawService = drawService;
        this.addMullionService = addMullionService;
        this.rulesService = rulesService;
        this.$cookies = $cookies;
        this.customDimensionColorRuleService = customDimensionColorRuleService;
        this.basementWindowRulesService = basementWindowRulesService;
        this.duplexMullionRulesService = duplexMullionRulesService;

        this.data = [];
        this.accessoriesModal = {
            accessories: {
                multiSelect: true,
                type: 'accessory',
                fieldName: 'accessories',
                title: 'ACCESSORIES',
                selectedOptions: null,
                options: [],
            },
            packets: {
                multiSelect: false,
                type: 'packet',
                fieldName: 'packet',
                title: 'PACKETS',
                selectedOptions: null,
                options: [],
            },
        };
        this.discount = 0;
        this.netDiscount = 0;
        this.price = 0;
        this.priceForRegularCustomer = 0;
        this.discountForRegularCustomer = 0;
        this.netPrice = 0;
        this.formattedPrices = {};
        this.discountPercentageValue = 0;
        this.quantity = 1;
        this.accesoryData = [];
        this.isB2bCustomer = false;
        this.priceReload = false;
        this.calculatedPrice = false;
        this.userAddedDivider = false;
        this.hingeSideTypes = ['windowSingleTurnTiltOrTurnHingeSide', 'activeSash', 'activeDoorSash', 'mirrorReflection', 'hingeSide'];
        this.displayDimensionColorRuleNotice = false;
        this.displayBasementWindowRuleNotice = false;
        this.isDuplexMullionAvailable = true;

        $translate('MUNTIN_CHANGE_INFO').then((infoText) => {
            this.muntinChangeInfo = infoText;
        });

        $translate('MUNTIN_DIDNT_CHANGE_INFO').then((infoText) => {
            this.muntinDidntChangeInfo = infoText;
        });

        $translate('MAX_DIMENSIONS_NOTICE').then((infoText) => {
            this.maxDimentionsNotice = infoText;
        });
    }

    hasGlazingSpacers() {
        return this.data.included.glazingSpacers.length > 1;
    }

    isDefaultGlazingSpacerAluminium() {
        return this.data.productInfo.isDefaultSpacerAluminium;
    }

    getAttributes() {
        return this.data.data[0].attributes;
    }

    getAttribute(field) {
        return this.data.data[0].attributes[field];
    }

    /**
     * Get current configuration height
     *
     * @returns {Int} Height in mm
     * @memberof DataService
     */
    getHeight() {
        return Math.floor(this.getAttribute('height'));
    }

    /**
     * Get current configuration width
     *
     * @returns {Int} Width in mm
     * @memberof DataService
     */
    getWidth() {
        return Math.floor(this.getAttribute('width'));
    }

    /**
     * Get current product type
     *
     * @return {String} Product type
     */
    getProductType() {
        return this.data.data[0].type;
    }

    /**
     * Check whether we should use fixed glass price
     *
     * @returns {Boolean}
     * @memberof DataService
     */
    hasFixedGlassPrice() {
        if (this.getProductType() === 'door' && !this.data.productInfo.productIsFullGlass) {
            return true;
        }
        return false;
    }

    isEntranceDoor() {
        if (this.getProductType() === 'door') {
            return true;
        }
        return false;
    }

    isBalconyDoorOrEntranceDoor() {
        if (this.isEntranceDoor()) {
            return true;
        }
        if (this.getProductType() === 'window' && [6, 7].indexOf(this.data.productInfo.configurationLayout.windowFunctionId) !== -1) {
            return true;
        }
        return false;
    }

    getData() {
        // this.updateInitialMullionsAndDividers();

        const dataCopy = cloneDeep(this.data);
        dataCopy.included = [];

        return dataCopy;
    }

    getMoreInfo(field) {
        let moreInfo;

        forEach(this.getAttributeOptions('moreInfo'), (el) => {
            if (el.attributes.field === field) {
                moreInfo = el;
                return false;
            }

            return true;
        });

        return moreInfo;
    }

    set quantity(value) {
        privQuantity = value;
        this.jsonService.updateField('quantity', value);
        if (angular.isDefined(this.data.data)) {
            this.updateDataAttribute('quantity', value);
            this.getData();
        }
    }

    get quantity() {
        return privQuantity;
    }

    updateHandleSide() {
        const hingeSide = this.getSelectedOptionId('hingeSide');
        const activeSash = this.getSelectedOptionId('activeSash');

        if (hingeSide) {
            this.jsonService.updateHingeSide(hingeSide, this.data.data[0].attributes.defaultInsideView);
        }
        if (activeSash) {
            this.jsonService.updateActiveSash(activeSash);
        }
    }

    reset(fieldName, refreshPrice = true) {
        if (fieldName === 'accessories') {
            this.updateSelectedOptions('packet', [-1], 'packet', false);
            this.updateSelectedOptions('accessories', []);

            return this.accesoryData;
        }
        if (fieldName === 'handleInsideAccessories' || fieldName === 'handleOutsideAccessories') {
            this.updateSelectedOptions(fieldName, [], null, refreshPrice);

            return [];
        }
        const initialID = this.jsonService.jsonBuilderService.getInitialValueId(fieldName);

        this.updateSelectedOptions(fieldName, [initialID], null, refreshPrice);

        return initialID;
    }

    getSelectedOptionId(fieldName) {
        if (angular.isUndefined(this.data.data[0].relationships[fieldName])) {
            return null;
        }

        const selected = this.data.data[0].relationships[fieldName].data;
        let ids = null;
        if (isArray(selected)) {
            ids = selected;
        } else if (angular.isUndefined(selected)) {
            ids = null;
        } else {
            ids = selected.id;
        }
        return ids;
    }

    getSelectedOption(fieldName, type) {
        const selectedId = this.getSelectedOptionId(fieldName);

        if (selectedId === null) {
            return null;
        }

        let selectedOption = null;

        if (isArray(selectedId)) {
            selectedOption = [];

            forEach(selectedId, (el) => {
                const selected = find(
                    this.data.included[type], el1 => el1.id === el.id
                );

                if (angular.isDefined(selected)) {
                    selectedOption.push(selected);
                }
            });
        } else {
            selectedOption = find(
                this.data.included[type], el => el.id === selectedId
            );
        }

        return selectedOption;
    }

    getAttributeOptions(type) {
        return this.data.included[type];
    }

    getAttributeOption(type, id) {
        if (angular.isUndefined(this.data.included[type])) {
            return null;
        }
        return find(this.data.included[type], element => element.id === id);
    }

    getColorPalettes() {
        return this.data.included.colorPalettes;
    }

    getColorPalette(fieldName, type) {
        const selectedOption = this.getSelectedOption(fieldName, type);
        const paletteId = this.getColorPaletteIdFromColor(selectedOption);
        const palettes = this.getColorPalettes();
        const palette = palettes.find(elem => parseInt(elem.id, 10) === parseInt(paletteId, 10));

        return palette;
    }

    getBackgroundColorCode(fieldName, type) {
        const selectedOption = this.getSelectedOption(fieldName, type);

        return selectedOption.attributes.hex;
    }

    getColorPaletteIdFromColor(color) {
        return color.attributes.paletteId;
    }

    getOptionAvailableStatus(type) {
        const attributeOptions = this.getAttributeOptions(type);
        const selectedOption = this.getSelectedOptionId(type);

        return !!(attributeOptions || selectedOption);
    }

    getGlassessOptions() {
        const glassOptionsInside = this.data.included.glass.filter(glass => glass.attributes.canBeInside === true);
        const glassOptionsOutside = this.data.included.glass.filter(glass => glass.attributes.canBeOutside === true);

        const outsideGlass = this.getSelectedOptionId('outsideGlass');
        const insideGlass = this.getSelectedOptionId('insideGlass');

        const options = [];

        const glazing = this.config.glazingGlass;

        forEach(glazing, (el, index) => {
            if (el.attributes.placement === 'inside') {
                options.push({
                    options: glassOptionsInside,
                    glazing: el,
                    selectedGlass: insideGlass,
                });
            }
            if (el.attributes.placement === 'outside') {
                options.push({
                    options: glassOptionsOutside,
                    glazing: el,
                    selectedGlass: outsideGlass,
                });
            }
        });

        return options;
    }

    getInitialApiObject() {
        return this.jsonService.getInitialApiObject();
    }

    getInitialData() {
        return this.initialData;
    }

    getItem(item) {
        if (angular.isArray(item)) {
            return {};
        }
        const options = this.getAttributeOptions(item.type);
        const currentItem = find(options, el => parseInt(el.id, 10) === parseInt(item.id, 10));

        return currentItem;
    }

    getObjectForApiRequest() {
        const apiRequestObject = [];
        const data = this.getData();
        this.jsonService.jsonObject.drawing = this.drawService.getData(this.jsonService.jsonObject);
        apiRequestObject.push(data.data[0]);
        apiRequestObject.push(this.jsonService.jsonObject);

        return { data: apiRequestObject, productInfo: data.productInfo };
    }

    getPacketItems(packet) {
        const itemsPacket = [];
        const allPackets = this.getAttributeOptions(packet.data.type);
        const currentPacket = find(allPackets,
            el => parseInt(el.id, 10) === parseInt(packet.data.id, 10)
        );

        forEach(currentPacket.attributes, (el, key) => {
            let name = key;
            if (key === 'glazingWidth') {
                name = 'glazing';
            } else if (key === 'insideGlass' || key === 'outsideGlass') {
                name = 'glass';
            }
            if (key !== 'apiId') {
                const item = find(this.getAttributeOptions(name),
                    el1 => parseInt(el1.id, 10) === parseInt(el, 10)
                );
                if (itemsPacket.indexOf(item) < 0) {
                    itemsPacket.push(item);
                }
            }
        });

        return itemsPacket;
    }

    getSelectedAccessories() {
        return this.getSelectedOption('accessories', 'accessory');
    }

    getTotalPrice() {
        return this.formattedPrices.totalPrice;
    }

    getPriceWithoutDiscount() {
        return this.formattedPrices.totalPriceWithoutDiscount;
    }

    getTotalNetPrice() {
        return this.formattedPrices.totalNetPrice;
    }

    getTotalPriceWithoutDiscountForRegularCustomer() {
        return this.formattedPrices.totalRegularWithoutDiscount;
    }

    getTotalPriceForRegularCustomer() {
        return this.formattedPrices.totalRegularPrice;
    }

    getDiscountForRegularCustomer() {
        return this.formattedPrices.totalRegularDiscount;
    }

    getDiscountPercentageValue() {
        return this.discountPercentageValue;
    }

    getIsB2bCustomer() {
        return this.isB2bCustomer;
    }

    getDiscountValue() {
        return this.formattedPrices.totalDiscount;
    }

    reloadProductWithNewSerie(seriesId) {
        const itemId = this.apiService.itemId;
        const series = this.data.included.series;
        const newSerie = series.filter(serie => +serie.id === seriesId);
        const newSerieSlug = newSerie[0].attributes.slug.toLowerCase();
        const type = this.data.productInfo.productType.toLowerCase();
        const material = this.data.productInfo.productMaterial;
        const productSlug = this.data.productInfo.productSlug;
        const $window = this.$window;
        const path = `${$window.location.protocol}//${$window.location.host}`;
        let route = `${path}/${type}/${material}/${newSerieSlug}/${productSlug}`;
        if (angular.isDefined(itemId)) {
            route = `${route}/${itemId}`;
        }
        localStorage.setItem('shape', JSON.stringify({
            height: Math.floor(this.getAttribute('height')),
            width: Math.floor(this.getAttribute('width')),
            bottom: this.getAttribute('bottomPanel'),
            unit: this.getSelectedOptionId('unit'),
            hingeSide: this.hingeSideTypes.slice().reverse().map(t => this.getSelectedOptionId(t)).find(t => t)
        }));
        $window.location.href = route;
    }

    reloadProductWithNewGlazing(newGlazingId, currentGlazingId) {
        const glazings = this.data.included.glazing;
        const currentGlazing = glazings.filter(glazing => +glazing.id === +currentGlazingId)[0];
        const newGlazing = glazings.filter(glazing => +glazing.id === +newGlazingId)[0];
        let currentGlassNumber = '';
        let newGlassNumber = '';

        if (currentGlazing.attributes.width === newGlazing.attributes.width) {
            return false;
        }

        if (+currentGlazing.attributes.chambers === 1) {
            currentGlassNumber = '2-glas';
            newGlassNumber = '3-glas';
        } else {
            currentGlassNumber = '3-glas';
            newGlassNumber = '2-glas';
        }

        const serie = this.data.productInfo.seriesSlug;
        const type = this.data.productInfo.productType.toLowerCase();
        const material = this.data.productInfo.productMaterial;
        const productSlug = this.data.productInfo.productSlug;
        const newProductSlug = productSlug.replace(currentGlassNumber, newGlassNumber);
        const $window = this.$window;
        const path = `${$window.location.protocol}//${$window.location.host}`;
        const route = `${path}/${type}/${material}/${serie}/${newProductSlug}`;
        localStorage.setItem('shape', JSON.stringify({
            height: Math.floor(this.getAttribute('height')),
            width: Math.floor(this.getAttribute('width')),
            bottom: this.getAttribute('bottomPanel'),
            unit: this.getSelectedOptionId('unit'),
            hingeSide: this.hingeSideTypes.slice().reverse().map(t => this.getSelectedOptionId(t)).find(t => t)
        }));
        $window.location.href = route;
    }

    setInitialData(data) {
        this.data = data;

        if (!this.isBlindProduct()) { //@todo: blinds
            this.setInitialDataForWindowAndDoor(data);
        } else {
            this.setInitialDataForBlinds(data);
        }
    }

    setInitialDataForWindowAndDoor(data) {
        data.rules.original_handle_quantity = data.rules.handle_quantity;
        this.initialData = cloneDeep(data);
        this.sashesService.setData(data);
        this.accesoryData = this.data.data[0].relationships.accessories.data.map(el => el.id);

        this.quantity = Number(this.data.data[0].attributes.quantity);
        this.windowDimensionsService.setTopLightFields(this.data.data[0].attributes.topLightFields);
        this.windowDimensionsService.setStandardFields(this.data.data[0].attributes.standardFields);
        this.windowDimensionsService.setWindowHeight(this.data.data[0].attributes.height);
        this.windowDimensionsService.setWindowWidth(this.data.data[0].attributes.width);
        if (
            this.getAttributes().dividersHorizontal > 0 ||
            this.getAttributes().dividersVertical > 0
        ) {
            this.userAddedDivider = true;
        }
        this.jsonService.setInitialObject();
        this.setInitialMullionsAndDividers(this.initialData);
        this.setInitialMullionSetup(this.initialData);
        this.sortPacket();
        this.checkDuplexMullionAvailability();
    }

    setInitialDataForBlinds(data) {
        this.initialData = cloneDeep(data);
        this.sashesService.setData(data);
        this.accesoryData = this.data.data[0].relationships.accessories.data.map(el => el.id);
    }

    setInitialMullionSetup(data) {
        const mullionSetupId = data.data[0].relationships.glazingBar.data.id;

        if (!mullionSetupId) {
            return false;
        }
        const mullionSetupDetails = this.getAttributeOption('glazingBar', mullionSetupId);
        this.addMullionService.setMullionSetup(mullionSetupDetails);
    }

    setInitialMullionsAndDividers(data) {
        const dataAttributes = data.data[0].attributes;

        this.sashesService.mullionsVert = dataAttributes.muntinsVertical || 0;
        this.sashesService.mullionsHor = dataAttributes.muntinsHorizontal || 0;
        this.sashesService.dividersVert = dataAttributes.dividersVertical || 0;
        this.sashesService.dividersHor = dataAttributes.dividersHorizontal || 0;
    }

    sortPacket() {
        const allPackets = this.getAttributeOptions('packet');

        allPackets.sort((a, b) => {
            if (isEmpty(a.relationships) || isEmpty(b.relationships)) {
                return -1;
            }
            return b.relationships.accessories.data.length - a.relationships.accessories.data.length;
        });
    }

    setInitialPacket() {
        let packetComponents = [];

        if (this.getProductType() === 'door') {
            packetComponents = ['accessories', 'hingeType'];
        } else {
            packetComponents = ['accessories', 'hingeType', 'handleInside', 'handleOutside'];
        }
        forEach(packetComponents, (el) => {
            const initialId = this.jsonService.jsonBuilderService.getInitialValueId(el);
            if (el !== 'accessories' && initialId) {
                this.updateSelectedOptions(el, [initialId], el, false);
            } else if (el === 'accessories') {
                this.updateSelectedOptions(el, this.accesoryData, 'packet', false);
            }
        });
    }

    updatePacketPrice(packetData) {
        const packetAttributes = packetData.attributes;
        const allPackets = this.getAttributeOptions('packet');
        const currentPacket = find(allPackets, el => el.id === packetData.id);

        currentPacket.attributes.regularPrice = packetAttributes.regularPrice;
        currentPacket.attributes.regularSaving = round(
            packetAttributes.regularNormalPrice - packetAttributes.regularPrice,
            2
        );
        currentPacket.attributes.price = packetAttributes.price_packet;
        currentPacket.attributes.netPrice = packetAttributes.net_price_packet;
        currentPacket.attributes.value = packetAttributes.price_normal;
        currentPacket.attributes.netValue = packetAttributes.net_price_normal;
        currentPacket.attributes.saving = round(
            packetAttributes.price_normal - packetAttributes.price_packet,
            2
        );
        currentPacket.attributes.netSaving = round(
            packetAttributes.net_price_normal - packetAttributes.net_price_packet,
            2
        );
    }

    updateAccessoryPrice(accessoryData) {
        const accessoryAttributes = accessoryData.attributes;
        const allAccessories = this.getAttributeOptions('accessory');
        const currentAccessory = find(allAccessories, el => el.id === accessoryData.id);

        if (angular.isDefined(currentAccessory)) {
            currentAccessory.attributes.price = accessoryAttributes.price;
            currentAccessory.attributes.priceAfterDiscount = accessoryAttributes.priceAfterDiscount;
            currentAccessory.attributes.netPrice = accessoryAttributes.netPrice;
            currentAccessory.attributes.netPriceAfterDiscount = accessoryAttributes.netPriceAfterDiscount;
            currentAccessory.attributes.regularPrice = accessoryAttributes.regularPrice;
            currentAccessory.attributes.regularPriceAfterDiscount = accessoryAttributes.regularPriceAfterDiscount;
        }
    }

    setPrice() {
        this.priceReload = true;
        this.freshPrice = false;

        this.apiService.recalculatePrice(this.getObjectForApiRequest()).then((data) => {
            if (data.meta.success) {
                const currentPrice = data.data[0].price;
                const currentNetPrice = data.data[0].netPrice;
                const regularCustomerPrice = data.data[0].regularCustomerPrice;
                this.basePrice = data.data[0].basePrice;
                this.isB2bCustomer = data.data[0].isB2bCustomer;
                this.discount = data.data[0].discount;
                this.price = Math.ceil(currentPrice - this.discount);
                this.priceForRegularCustomer = Math.ceil(regularCustomerPrice - data.data[0].discountValueForRegularCustomer);
                this.discountForRegularCustomer = Math.ceil(data.data[0].discountValueForRegularCustomer);
                this.netDiscount = data.data[0].netDiscount;
                this.netPrice = Math.ceil(currentNetPrice - this.netDiscount);
                this.formattedPrices = data.data[0].formatted;
                this.discountPercentageValue = data.data[0].lineDiscountValue;
                this.jsonService.updateField('price', cloneDeep(this.price));
                this.jsonService.blindsError = false;
                this.jsonService.dimError = false;

                if (data.meta.debug) {
                    console.log(data.data[0]); // eslint-disable-line
                }

                forEach(data.data, (el) => {
                    if (el.type === 'packet') {
                        this.updatePacketPrice(el);
                    }
                    if (el.type === 'accessory') {
                        this.updateAccessoryPrice(el);
                    }
                });
            } else {
                if (data.meta.errors.indexOf('No blinds pricelist value') >= 0) {
                    this.jsonService.blindsError = true;
                } else {
                    this.jsonService.dimError = true;
                }
                this.discount = 0;
                this.price = 0;
                this.jsonService.updateField('price', 0);
            }
            this.freshPrice = true;
            this.priceReload = false;
            if (!this.calculatedPrice) {
                this.calculatedPrice = true;
                this.validateAccessories();
            }
        });
    }

    resetGlazing() {
        const glassOptionsInside = this.data.included.glass.filter(glass => glass.attributes.canBeInside === true);
        const glassOptionsOutside = this.data.included.glass.filter(glass => glass.attributes.canBeOutside === true);

        this.updateSelectedOptions('insideGlass', glassOptionsInside[0].id, 'glass', false);
        this.updateSelectedOptions('outsideGlass', glassOptionsOutside[0].id, 'glass', false);
        this.updateSelectedOptions('ornament', 1, 'ornament', true);
    }

    updateInitialMullionsAndDividers() {
        const dividers = {
            vertical: this.windowDimensionsService.getVerticalDividersLength(),
            horizontal: this.windowDimensionsService.getHorizontalDividersLength()
        };
        const muntins = {
            vertical: this.windowDimensionsService.getMullionsVert(),
            horizontal: this.windowDimensionsService.getMullionsHor(),
        };
        this.updateDataAttribute('muntinsHorizontal', muntins.horizontal);
        this.updateDataAttribute('muntinsVertical', muntins.vertical);
        this.updateDataAttribute('dividersHorizontal', dividers.horizontal);
        this.updateDataAttribute('dividersVertical', dividers.vertical);
    }

    divideSashesByMullionsAndDividers(refreshPrice = true) {
        const dividersVert = this.sashesService.dividersVert;
        const dividersHor = this.sashesService.dividersHor;
        const maxBarsVert = this.windowDimensionsService.maxBarsVert;
        const maxBarsHor = this.windowDimensionsService.maxBarsHor;
        const mullionsVert = this.sashesService.mullionsVert;
        const mullionsHor = this.sashesService.mullionsHor;

        this.sashesService.resetSashes();

        if (dividersVert == 0 && dividersHor == 0) {
            this.sashesService.dividersService.resetDividers();
        }
        if (dividersVert > maxBarsVert - mullionsVert) {
            this.sashesService.dividersVert = maxBarsVert - mullionsVert;
        }
        if (dividersHor > maxBarsHor - mullionsHor) {
            this.sashesService.dividersHor = maxBarsHor - mullionsHor;
        }
        if (mullionsVert >= maxBarsVert - dividersVert) {
            this.sashesService.mullionsVert = maxBarsVert - dividersVert;
        }
        if (mullionsHor >= maxBarsHor - dividersHor) {
            this.sashesService.mullionsHor = maxBarsHor - dividersHor;
        }
        for (let i = 0; i < this.sashesService.dividersVert; ++i) {
            this.sashesService.addSashDivider('vertical');
        }
        for (let i = 0; i < this.sashesService.dividersHor; ++i) {
            this.sashesService.addSashDivider('horizontal');
        }
        for (let i = 0; i < this.sashesService.mullionsVert; ++i) {
            this.sashesService.addMullions('vertical');
        }
        for (let i = 0; i < this.sashesService.mullionsHor; ++i) {
            this.sashesService.addMullions('horizontal');
        }
        this.sashesService.updateSashesDimensions();

        if (refreshPrice) {
            this.$rootScope.$emit('updateDrawing');
        }
    }

    updateSelectedOptions(fieldName, selectedOptions, type, refreshPrice = true) {
        const currentGlazing = (!this.isBlindProduct()) ? this.data.data[0].relationships.glazing.data.id : null;
        const currentSerie = this.data.data[0].relationships.series.data.id;
        const oldData = this.data.data[0].relationships[fieldName].data;
        const newOption = angular.isArray(selectedOptions) ? selectedOptions[0] : selectedOptions;
        if (isArray(this.data.data[0].relationships[fieldName].data)) {
            this.data.data[0].relationships[fieldName].data = [];

            forEach(selectedOptions, (el) => {
                if (el !== -1) {
                    let newType = fieldName === 'accessories' && this.isSelectedInPacket(el) ? 'packet' : 'accessory';
                    this.data.data[0].relationships[fieldName].data.push({
                        id: el,
                        type: newType,
                    });
                }
            });
            if (fieldName === 'accessories') {
                this.accesoryData = this.data.data[0].relationships.accessories.data.map(el => el.id);
                const accessoryData = this.getSelectedOption('accessories', 'accessory');
                const fixedAccessoryData = this.data.included.accessory.find(el => el.attributes.name == 'Fast-i-fast');
                if (fixedAccessoryData) {
                    const fixFound = accessoryData.find(el => el.id == fixedAccessoryData.id);
                    if (fixFound) {
                        this.jsonService.updateFixOption(2);
                    } else {
                        this.jsonService.updateFixOption(1);
                    }
                }
                this.updateIncludedAccessories();
                this.jsonService.updateAccessories(selectedOptions, accessoryData);
            }
        } else if (fieldName === 'series' && currentSerie !== newOption) {
            this.reloadProductWithNewSerie(parseInt(newOption, 10));
        } else if (fieldName === 'glazing' && currentGlazing !== newOption) {
            this.reloadProductWithNewGlazing(parseInt(newOption, 10), currentGlazing);
        } else if (fieldName === 'insideGlass' || fieldName === 'outsideGlass' || fieldName === 'ornament') {
            this.data.data[0].relationships[fieldName].data.id = selectedOptions;
        } else if (fieldName === 'hingeSide') {
            this.data.data[0].relationships[fieldName].data.id = newOption;
            this.jsonService.updateNestedField(fieldName, newOption, this.data.data[0].attributes.defaultInsideView);
        } else if (angular.isDefined(newOption) || fieldName === 'mirrorReflection') {
            this.data.data[0].relationships[fieldName].data.id = newOption;
            this.jsonService.updateNestedField(fieldName, newOption);
        }
        if (angular.isDefined(newOption) && this.getProductType() !== 'door') {
            this.updatePacketOptions(fieldName, oldData);
        }
        if (!this.data.data[0].relationships[fieldName].data[0] && fieldName === 'packet') {
            this.setInitialPacket();
        }
        this.validateAccessories();

        if (
            fieldName === 'accessories' ||
            fieldName === 'packet'
        ) {
            this.$rootScope.$emit('accessoriesUpdate');
            this.populateAccessoriesModal();
        }
        if (refreshPrice) {
            // we need a small timeout here because without it the price is buggy
            // and has incorrect value...
            setTimeout(() => { this.setPrice() }, 100);
        }
    }

    updateIncludedAccessories() {
        this.data.data[0].relationships.includedAccessories.data = [];
        this.data.included.includedAccessories.forEach(includedAccessory => {
            if (!this.data.data[0].relationships.accessories.data.some(accessory => {
                    const accessoryData = this.getAttributeOption('accessory', accessory.id);
                    if (accessoryData.attributes.accessoryType === includedAccessory.attributes.accessoryType) {
                        return true;
                    }
                })) {
                this.data.data[0].relationships.includedAccessories.data.push({
                    id: includedAccessory.id,
                    type: 'includedAccessory'
                })
            }
        })
    }

    getSelectedOptionIds(relationship) {
        let selectedOptions = this.getSelectedOptionId(relationship.fieldName);

        if (relationship.multiSelect) {
            const ids = [];

            forEach(selectedOptions, (el) => {
                ids.push(el.id);
            });
            selectedOptions = ids;
        }
        return selectedOptions;
    }

    populateAccessoriesModal() {
        this.accessoriesModal.accessories.options = this.getAttributeOptions('accessory');
        this.accessoriesModal.accessories.selectedOptions = this.getSelectedOptionIds(this.accessoriesModal.accessories);
        this.accessoriesModal.packets.options = this.getAttributeOptions('packet');
        this.accessoriesModal.packets.selectedOptions = this.getSelectedOptionIds(this.accessoriesModal.packets);
    }

    updateDataAttribute(fieldName, value) {
        this.data.data[0].attributes[fieldName] = value;
    }

    updateIncludedAttributes(fieldName, value) {
        this.data.included[fieldName][0].attributes.data = value;
    }

    updatePacketOptions(fieldName, oldData) {
        if (fieldName === 'packet') {
            const currentPackets = this.getSelectedOptionId('packet');
            const logicPacketRelationships = {
                accessories: this.getSelectedOptionId('accessories'),
                hingeType: {},
                handleInside: {},
                handleOutside: {},
                glazingSpacers: {},
            };
            forEach(currentPackets, (el) => {
                const tmpPacket = find(this.getAttributeOptions('packet'),
                    el1 => el1.id === el.id
                );
                if (tmpPacket.relationships.hingeType) {
                    logicPacketRelationships.hingeType = tmpPacket.relationships.hingeType;
                }
                if (tmpPacket.relationships.handle) {
                    logicPacketRelationships.handleInside = tmpPacket.relationships.handle;
                    logicPacketRelationships.handleOutside = tmpPacket.relationships.handle;
                }
                if (tmpPacket.attributes.hasWarmEdgeSpacer) {
                    const availableWarmEdgeSpacers = this.data.included.glazingSpacers.filter(
                        glazingSpacer => glazingSpacer.type === 2
                    );
                    logicPacketRelationships.glazingSpacers = availableWarmEdgeSpacers[0];
                }
                forEach(tmpPacket.relationships.accessories, (el1) => {
                    forEach(el1, (el2) => {
                        const up = find(logicPacketRelationships.accessories, el3 =>
                            parseInt(el3.id, 10) === parseInt(el2.id, 10)
                        );
                        if (!up) {
                            logicPacketRelationships.accessories.push(el2);
                        }
                    });
                });
            });
            const handleInsideId = this.getSelectedOptionId('handleInside');
            const handleOutsideId = this.getSelectedOptionId('handleOutside');

            forEach(oldData, (el) => {
                const tmpPacket = find(this.getAttributeOptions('packet'),
                    el1 => el1.id === el.id
                );
                if (!currentPackets.some(el1 => el1.id === el.id) &&
                    tmpPacket.relationships.handle &&
                    tmpPacket.relationships.handle.data.id == handleInsideId
                ) {
                    const initialId = this.jsonService.jsonBuilderService.getInitialValueId('handleInside');
                    logicPacketRelationships.handleInside = {
                        data: {
                            id: initialId,
                            type: 'handle'
                        }
                    };
                }
                if (!currentPackets.some(el1 => el1.id === el.id) &&
                    tmpPacket.relationships.handle &&
                    tmpPacket.relationships.handle.data.id == handleOutsideId
                ) {
                    const initialId = this.jsonService.jsonBuilderService.getInitialValueId('handleOutside');
                    logicPacketRelationships.handleOutside = {
                        data: {
                            id: initialId,
                            type: 'handle'
                        }
                    };
                }
            });
            forEach(logicPacketRelationships, (el1, key) => {
                if (key === 'glazingSpacers') {
                    this.updateSelectedOptions(key, el1.id, key, true);
                } else if (key !== 'accessories' && key !== 'glazingSpacers' && el1.data) {
                    this.updateSelectedOptions(key, [el1.data.id], key, false);
                } else if (key === 'accessories') {
                    const accesoriesIds = el1.map(accessory => accessory.id);
                    this.updateSelectedOptions('accessories', accesoriesIds, 'packet', false);
                }
            });
        } else if (fieldName === 'handleInside' || fieldName === 'handleOutside') {
            const allPackets = this.getAttributeOptions('packet');
            const currentPackets = this.getSelectedOptionId('packet');
            const handleId = this.getSelectedOptionId(fieldName);
            if (!handleId) {
                return;
            }
            allPackets.filter(packet =>
                packet.relationships.handle &&
                packet.relationships.handle.data.id != handleId &&
                currentPackets.some(cur => packet.id == cur.id)
            ).forEach(packet => this.removePacket(packet.id));
        }
    }

    validateData(data) {
        const included = data.included;
        forEach(data.data[0].relationships, (el) => {
            if (el.data.id) {
                const includedType = included[el.data.type];
                const result = find(includedType,
                    el1 => el1.id === el.data.id
                );

                if (angular.isUndefined(result) && angular.isDefined(includedType) && includedType.length > 0) {
                    const currentRelationship = el;
                    // mapping for old mullions (need this when edit offer)
                    if (el.data.type === 'dividerSize') {
                        const newMullionId = included.mullionMapping[el.data.id];
                        if (newMullionId) {
                            currentRelationship.data.id = newMullionId;
                        }
                    }
                    // mapping for old muntins (need this when edit offer)
                    if (el.data.type === 'mullionSize') {
                        const newMuntinId = included.muntinsMapping[el.data.id];
                        if (newMuntinId) {
                            currentRelationship.data.id = newMuntinId;
                        }
                    }
                    currentRelationship.data.id = includedType[0].id;
                }
            }
        });
    }

    separatePriceThousandsBySpace(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    /**
     * Check whether product has glass
     *
     * @returns boolean
     * @version 1.0
     */
    isProductWithGlass() {
        return this.data.productInfo.productHasGlass;
    }

    /**
     * Check whether product has color options
     *
     * @returns boolean
     * @version 1.0
     */
    isProductWithColor() {
        return !this.data.productInfo.productHideColors;
    }

    isPacketSelected() {
        const packet = this.getSelectedOptionId('packet');
        return packet != null && packet[0] != null;
    }

    isSelectedInPacket(id, packetId) {
        const packet = this.getSelectedOption('packet', 'packet');
        return packet && find(packet, p => (!packetId || packetId == p.id) && find(p.relationships.accessories.data, el => el.id == id) != null) != null;
    }

    hasWarmEdgeInPacket(packetId) {
        const packets = this.getSelectedOption('packet', 'packet');

        return packets &&
            find(packets, packet => (!packetId || packetId == packet.id) &&
                packet.attributes.hasWarmEdgeSpacer) != null;
    }

    removePacketAccessories(id) {
        if (isArray(this.data.data[0].relationships['accessories'].data)) {
            this.data.data[0].relationships['accessories'].data = this.data.data[0].relationships['accessories'].data.filter(
                el => !this.isSelectedInPacket(el.id, id) || this.data.included['defaultAccessories'][el.id]
            );
            this.accesoryData = this.data.data[0].relationships['accessories'].data.map(el => el.id);
        }
        const outerColor = this.getSelectedOption('outer', 'color');

        if (
            this.hasWarmEdgeInPacket(id) &&
            this.data.data[0].relationships.glazingSpacers &&
            this.hasGlazingSpacers()
        ) {
            if (!this.isDefaultGlazingSpacerAluminium()) {
                if (outerColor.attributes.isWhite) {
                    this.setGlazingSpacer(this.defaultGlazingSpacers['white']);
                } else {
                    this.setGlazingSpacer(this.defaultGlazingSpacers['other']);
                }
            } else {
                const aluminiumGlazingSpacer = this.getAttributeOptions('glazingSpacers').find(
                    glazingSpacer => glazingSpacer.type === 1
                );
                this.setGlazingSpacer(aluminiumGlazingSpacer.id);
            }
        }
    }

    setGlazingSpacer(selectedOption) {
        this.data.data[0].relationships['glazingSpacers'].data.id = selectedOption;
    }

    validateAccessories() {
        const pair = Number(this.data.data[0].attributes.standardFields) === 2;
        const tilt = Number(this.getSelectedOptionId('hingeSide')) === 3 ||
            (this.data.rules.turn_tilt &&
                Number(this.data.data[0].attributes.standardFields) === 1 &&
                this.jsonService.jsonObject.sashes.length > 0 &&
                this.jsonService.jsonObject.sashes[0].type.handlePosition === 'T');
        const width = this.data.data[0].attributes.width;
        const height = this.data.data[0].attributes.height;
        const material = this.data.productInfo.productMaterial;
        const allAccessories = this.getAttributeOptions('accessory');
        const selectedAccessories = this.getSelectedOption('accessories', 'accessory');
        const allPackets = this.getAttributeOptions('packet');
        const selectedPackets = this.getSelectedOption('packet', 'packet');
        let func = null;
        if (pair) {
            func = this.data.rules.handle_quantity === 2 ? 'fixed_mullion' : 'floating_mullion';
        } else if (this.data.rules.side_hung) {
            func = 'side_hung';
        } else if (tilt) {
            func = 'tilt';
        } else {
            func = 'turn_tilt';
        }
        const min_sizes = this.data.rules.min_sizes ? {
            hidden: this.data.rules.min_sizes.hidden[func],
            visible: this.data.rules.min_sizes.visible[func]
        } : null;
        const { dividerRequired, accessories, packets } = this.rulesService.validateAccessories({
            rules: this.data.rules,
            min_sizes,
            material,
            width,
            height,
            pair,
            tilt,
            allAccessories,
            selectedAccessories,
            allPackets,
            selectedPackets
        });
        if (dividerRequired) {
            this.addHorizontalDivider();
        }
        Object.entries(accessories).forEach(([id, available]) => {
            if (available) {
                this.unblockAccessory(id);
            } else {
                this.removeAndBlockAccessory(id);
            }
        });
        Object.entries(packets).forEach(([id, available]) => {
            if (available) {
                this.unblockPacket(id);
            } else {
                this.removeAndBlockPacket(id);
            }
        });
    }

    removeAndBlockAccessory(id) {
        this.data.data[0].relationships.accessories.data =
            this.data.data[0].relationships.accessories.data
            .filter(el => Number(id) !== Number(el.id));

        this.accesoryData = this.data.data[0].relationships.accessories.data.map(el => el.id);

        this.data.included.accessory
            .filter(el => Number(id) === Number(el.id))
            .forEach((accessory) => {
                accessory.blocked = true;

                if (Number(accessory.attributes.accessoryType) === 2) {
                    this.jsonService.updateFixOption(1);
                }
            });
    }

    removeAndBlockPacket(id) {
        this.removePacketAccessories(id);

        this.data.data[0].relationships.packet.data =
            this.data.data[0].relationships.packet.data
            .filter(el => Number(id) !== Number(el.id));

        this.data.included.packet
            .filter(el => Number(id) === Number(el.id))
            .forEach((packet) => {
                packet.blocked = true

                if ((
                        this.data.data[0].relationships.handleInside ||
                        this.data.data[0].relationships.handleOutside
                    ) &&
                    packet.relationships.handle
                ) {
                    const handle = find(this.data.included.handle, element => element.id === packet.relationships.handle.data.id);

                    // Set default handle only if handle from package is not available as solo option
                    if (angular.isUndefined(handle)) {
                        this.data.data[0].relationships.handleInside.data.id = this.jsonService.jsonBuilderService.getInitialValueId('handleInside');
                        this.data.data[0].relationships.handleOutside.data.id = this.jsonService.jsonBuilderService.getInitialValueId('handleOutside');
                    }
                }
            });
    }

    unblockAccessory(id) {
        const hingeTypeIds = [];
        this.data.included.accessory
            .filter(element => (element.attributes.accessoryType === '7' || element.attributes.accessoryType === '8'))
            .forEach((accessory) => {
                hingeTypeIds.push(accessory.id);
            });
        const isHingeSelected = find(this.accesoryData, accessoryId => (hingeTypeIds.indexOf(accessoryId) !== -1));

        this.data.included.accessory
            .filter(el => Number(el.id) === Number(id))
            .forEach((accessory) => {
                accessory.blocked = false;

                if (accessory.attributes.isDefault && !this.accesoryData.includes(accessory.id)) {
                    if (['7', '8'].indexOf(accessory.attributes.accessoryType) !== -1 && !isHingeSelected) {
                        this.data.data[0].relationships.accessories.data.push({
                            id: accessory.id,
                            type: 'accessory'
                        });
                        this.accesoryData = this.data.data[0].relationships.accessories.data.map(el => el.id);
                    } else if (['7', '8'].indexOf(accessory.attributes.accessoryType) === -1) {
                        this.data.data[0].relationships.accessories.data.push({
                            id: accessory.id,
                            type: 'accessory'
                        });
                        this.accesoryData = this.data.data[0].relationships.accessories.data.map(el => el.id);
                    }
                }
            });
    }

    unblockPacket(id) {
        this.data.included.packet
            .filter(el => Number(el.id) === Number(id))
            .forEach(packet => packet.blocked = false);
    }

    removePacket(id) {
        this.removePacketAccessories(id);
        this.data.data[0].relationships['packet'].data = this.data.data[0].relationships['packet'].data
            .filter(el => id != el.id);
    }

    addHorizontalDivider() {
        if (Number(this.data.data[0].attributes.dividersHorizontal) === 0) {
            this.addMullionService.addDivider('horizontal');
            this.addMullionService.addSystemDivider('horizontal');
        }
    }

    removeHorizontalDivider() {
        if (Number(this.data.data[0].attributes.dividersHorizontal) === 1) {
            this.sashesService.dividersHor--;
            this.addMullionService.updateDividers(false);
            this.addMullionService.removeSystemDivider('horizontal');
        }
    }

    validateDimensionColorRule(
        productId = this.data.data[0].id,
        width = this.data.data[0].attributes.width,
        height = this.data.data[0].attributes.height,
        color = this.getSelectedOption('outer', 'color')
    ) {
        this.displayDimensionColorRuleNotice = !!this.customDimensionColorRuleService.checkProductLimitation(productId, width, height, color);
    }

    hideColorOnDimensionColorRule(
        colorOption,
        productId = this.data.data[0].id,
        width = this.data.data[0].attributes.width,
        height = this.data.data[0].attributes.height
    ) {
        return this.customDimensionColorRuleService.hideColorOnDimensionOverLimit(productId, width, height, colorOption);
    }

    setMuntinColorBasedOnConstructionColor() {
        if (!this.addMullionService.selectedMullionSize) {
            this.addMullionService.selectedMullionSize = this.getSelectedOption('mullionSize', 'mullionSize');
        }
        if (!this.addMullionService.selectedMullionSize) {
            return true;
        }
        const muntinColorPalettes = this.getMuntinsColorPaletts();
        const insideMuntinsColors = muntinColorPalettes[this.addMullionService.selectedMullionSize.attributes.insideColourPaletteId];
        const outsideMuntinsColors = muntinColorPalettes[this.addMullionService.selectedMullionSize.attributes.outsideColourPaletteId];
        const constructionColor = this.getSelectedOption('outer', 'color');

        let defaultInsideColor = insideMuntinsColors.find(color => color.id === constructionColor.id);
        let defaultOutsideColor = outsideMuntinsColors.find(color => color.id === constructionColor.id);

        defaultInsideColor = (!defaultInsideColor) ? insideMuntinsColors.find(color => color.matched_colour_id === constructionColor.id) : defaultInsideColor;
        defaultOutsideColor = (!defaultOutsideColor) ? outsideMuntinsColors.find(color => color.matched_colour_id === constructionColor.id) : defaultOutsideColor;

        if (defaultInsideColor) {
            this.updateSelectedOptions('mullionColorInner', [defaultInsideColor.id], 'mullionColorInner', false);
        }
        if (defaultOutsideColor) {
            this.updateSelectedOptions('mullionColorOuter', [defaultOutsideColor.id], 'mullionColorOuter', false);
        }
        if (defaultInsideColor && defaultOutsideColor) {
            this.notificationService.displayNotificationInConfigurator(this.muntinChangeInfo);
        } else {
            this.notificationService.displayNotificationInConfigurator(this.muntinDidntChangeInfo);
        }
    }

    getMuntinsColorPaletts() {
        const palettes = {};

        // get unique palettes ids
        this.getAttributeOptions('mullionSize').forEach(element => {
            palettes[element.attributes.insideColourPaletteId] = [];
            palettes[element.attributes.outsideColourPaletteId] = [];
        });

        const paletteIds = Object.keys(palettes);
        let currentPaletteId = null;

        this.getAttributeOptions('color').forEach((color, i) => {
            color.attributes.paletteIds.forEach(paletteId => {
                const index = paletteIds.indexOf(String(paletteId));
                if (index > -1) {
                    currentPaletteId = paletteIds[index];
                    color.attributes.id = color.id;
                    palettes[currentPaletteId].push(color.attributes);
                }
            })
        });

        return palettes;
    }

    displayNotificationInConfigurator(text) {
        let newNotification = angular.element('.configurator__info-box.--template').clone(true);
        newNotification.children('.configurator__info-box-text').text(text);
        newNotification.removeClass('--template');
        setTimeout(function() {
            newNotification.remove();
        }, 10000);

        angular.element('.configurator__info-box-wrapper').append(newNotification);
    }

    isB2bMode() {
        return this.$cookies.get('b2b-homepage') === '1';
    }

    priceSwitchState() {
        return this.$cookies.get('display-end-customer-price') === '1';
    }

    isProductEligibleForGlazingRule() {
        return this.data.productInfo.productEligibleForGlazingRule;
    }

    isProductEligibleForOrnamentGlassRule() {
        return this.data.productInfo.isTwoGlazingProduct;
    }

    getMaxDimensionRules() {
        let maxDimensions = this.data.rules.max_dimension;
        if (Object.keys(maxDimensions).length > 0) {
            let currentColor = this.getSelectedOption('outer', 'color');

            if (currentColor.attributes.isWhite) {
                return this.data.rules.max_dimension.white;
            } else {
                return this.data.rules.max_dimension.color;
            }
        }

        return false;
    }

    isBlindProduct() {
        return this.data.data[0].type === 'roller_blind' ||
            this.data.data[0].type === 'internal_blind' ||
            this.data.data[0].type === 'plisse' ||
            this.data.data[0].type === 'vertical_blind';
    }

    isProductEligibleForBasementWindowRule() {
        return this.data.productInfo.productEligibleForBasementWindowRule;
    }

    validateBasementWindowRule(
        width = this.data.data[0].attributes.width,
        height = this.data.data[0].attributes.height,
    ) {
        this.displayBasementWindowRuleNotice = this.isProductEligibleForBasementWindowRule() && this.basementWindowRulesService.areConditionsMet(width, height);
    }

    displayNoticeAboutDimensionColorRule() {
        this.notificationService.displayNotificationInConfigurator(this.maxDimentionsNotice);
    }

    checkDuplexMullionAvailability() {
        const selectedInsideGlass = this.getSelectedOption('insideGlass', 'glass');
        const selectedOutsideGlass = this.getSelectedOption('outsideGlass', 'glass');
        const selectedSerie = this.getSelectedOption('series', 'series');
        const selectedMullionSize = this.getSelectedOption('mullionSize', 'mullionSize');

        if (
            this.duplexMullionRulesService.areConditionsMeet(
                selectedSerie,
                selectedInsideGlass,
                selectedOutsideGlass,
            )
        ) {
            this.isDuplexMullionAvailable = false;

            if (
                selectedMullionSize &&
                selectedMullionSize.attributes.barType === 'in_out_duplex'
            ) {
                this.removeDuplexMullionSize();
            }
        } else {
            this.isDuplexMullionAvailable = true;
        }
    }

    /**
     * Reset selected mullion size and colors to something other than in out duplex type
     */
    removeDuplexMullionSize() {
        const selectedMullionSize = this.getSelectedOption('mullionSize', 'mullionSize');
        const initialMullionSizeId = this.jsonService.jsonBuilderService.getInitialValueId('mullionSize');
        const initialMullionSizeDetails = this.getAttributeOption('mullionSize', initialMullionSizeId);
        const mullionSizes = this.getAttributeOptions('mullionSize');
        let newMullionSizeId = null;

        if (
            initialMullionSizeId === selectedMullionSize.id ||
            initialMullionSizeDetails.attrbutes.barType === 'in_out_duplex'
        ) {
            newMullionSizeId = mullionSizes.find(mullionSize => {
                return mullionSize.attributes.barType !== 'in_out_duplex';
            }).id;
        } else {
            newMullionSizeId = initialMullionSizeId;
        }
        this.updateSelectedOptions('mullionSize', newMullionSizeId, 'mullionSize', false);
        this.setMuntinColorBasedOnConstructionColor();
    }
}

DataService.$inject = [
    'jsonService',
    '$rootScope',
    'notificationService',
    '$window',
    'windowDimensionsService',
    'apiService',
    'config',
    'sashesService',
    'drawService',
    'addMullionService',
    'rulesService',
    '$cookies',
    '$translate',
    'customDimensionColorRuleService',
    'basementWindowRulesService',
    'duplexMullionRulesService',
];

export default angular.module('dataService', [])
    .service('dataService', DataService)
    .name;